import { CONTAINER_COPIED } from './actionTypes';

export default (designId, originalId, copyId) => ({
  type: CONTAINER_COPIED,
  payload: { designId, originalId, copyId },
});
